import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { productUnitsSymbol } from "constant"
import { formatMobilePhone, moment } from "utils"
import classes from "./RrTableRow.module.scss"

const RrTableRow = (props) => {
  const { dispatchedOrder } = props

  const [t] = useTranslation()

  return (
    <tr className={classes["table-row"]}>
      <td>
        {dispatchedOrder.customerFullName || t("بدون_نام")}
        <br />
        {formatMobilePhone(dispatchedOrder.customerMobilePhone)}
      </td>
      <td>
        {dispatchedOrder.code}
      </td>
      <td>
        {moment(dispatchedOrder.date).format("jYYYY/jMM/jDD")}
        <br />
        {moment(dispatchedOrder.date).format("HH:mm")}
      </td>
      <td>
        {moment(dispatchedOrder.paymentDate).format("jYYYY/jMM/jDD")}
        <br />
        {moment(dispatchedOrder.paymentDate).format("HH:mm")}
      </td>
      <td>
        <table className={classes["table"]}>
          <tbody>
            {dispatchedOrder.items.map((item, itemIndex) =>
              <tr key={itemIndex}>
                <td>{item.quantity}{t(productUnitsSymbol[item.unit])}</td>
                <td className={classes["name"]}>
                  {item.foodName}{item.isSimple ? "" : ` - ${item.option.name}`}{item.sku ? ` - ${item.sku}` : ""}
                </td>
                <td>{item.foodCode}</td>
              </tr>
            )}
          </tbody>
        </table>
      </td>
      <td>
        {dispatchedOrder.isDispatched ? t("خروج_از_انبار") : t("خروج_نخورده")}
        <br />
        {t("پرداخت_شده")}
      </td>
      <td>
        {dispatchedOrder.addedBySystem ? dispatchedOrder.addedByFullName : t("سایت")}
      </td>
      <td>
        {
          !!dispatchedOrder.date &&
          <Fragment>
            {moment(dispatchedOrder.date).format("jYYYY/jMM/jDD")}
            <br />
            {moment(dispatchedOrder.date).format("HH:mm")}
          </Fragment>
        }
      </td>
      <td>
        {dispatchedOrder.dispatchedByFullName}
      </td>
    </tr>
  )
}

export default React.memo(RrTableRow)